exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Sc-T1{width:100%;padding:30px 40px;font-size:20px}._3xJ7g{box-sizing:border-box;width:calc(100% - 60px);line-height:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:12px;padding:0 10px;border:1px solid #b6bac3;border-radius:4px}.e2i1y{color:#000}", ""]);

// exports
exports.locals = {
	"share-container": "Sc-T1",
	"shareContainer": "Sc-T1",
	"url-input": "_3xJ7g",
	"urlInput": "_3xJ7g",
	"share-button": "e2i1y",
	"shareButton": "e2i1y"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/mobile/components/share-mobile/popup-content/popup-content.styl
// module id = 1844
// module chunks = mobile/mobile mobile-overlay/mobile-overlay widget/strip widget/classic widget/compact